
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

/* Just a 404 error page*/
export default class Whoops extends Component {
    // constructor(props){
    //     super(props);
    // }

    componentDidMount() {

      }
    render(){
        
    
    return(
         <div className = 'center1'> 
            <Link to  = '/'> 
                <div id="msg404">       
                    <div className = 'ui fluid large negative button'>Four Oh Four</div>
                    <p tooltip><Icon name = 'home' size='massive'/></p>
                </div>
            </Link>



            <div ref="arc"></div>

        </div>
     )   
    }

}


// WEBPACK FOOTER //
// ./src/components/Whoops.js